import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import { getDealUsers } from '@dealstack/frontend/shared/dataExchange/services/project.service';
import type { DealEventFilterOption } from '@dealstack/frontend/app/pages/Project/DealEventLog/utils/dealEventLogFilterOptions.utils.ts';

const ACTOR_STALE_TIME_MS = 300_000;

export const useDealEventActors = (dealId: string, enabled: boolean) => {
	const endpoint = formatUnicorn(API_PATHS.DEAL_DEALID_USERS_GET, { dealId });

	const query = useQuery({
		queryKey: [endpoint],
		queryFn: () => getDealUsers(endpoint),
		enabled: enabled && !!dealId,
		staleTime: ACTOR_STALE_TIME_MS,
		gcTime: ACTOR_STALE_TIME_MS,
	});

	return useMemo<DealEventFilterOption[]>(
		() =>
			(query.data ?? []).map(({ id, email, firstName, lastName }) => ({
				value: id,
				label: [firstName, lastName].filter(Boolean).join(' ') || email,
			})),
		[query.data]
	);
};
